import CampaignV2ListPanel from "./campaignV2ListPanel.container"

export default CampaignV2ListPanel
